// extracted by mini-css-extract-plugin
module.exports = {"BetaBadge":"NewFeatureBadge_BetaBadge__2JfYk","Small":"NewFeatureBadge_Small__1zJM_"};